module.exports = __webpack_public_path__ + "img/website-sentosa.347a0345.svg";